<button (click)="openImportModal()" class="btn btn-primary" *ngIf="importNotebookEnabled$ | async">Import Notebook</button>
<!-- TODO: Add a button to open the import modal (Entry point) -->